// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import RemindFillSvg from '@rsuite/icon-font/lib/status/RemindFill';
var RemindFill = createSvgIcon({
  as: RemindFillSvg,
  ariaLabel: 'remind fill',
  category: 'status',
  displayName: 'RemindFill'
});
export default RemindFill;